module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"backToBooking":{"text":"Change order","link":"/booking"},"completeBooking":{"text":"Book now","link":"/booking/overview"}}}')
  delete Component.options._Ctor
}
